import { Signal } from 'typed-signals';
import type { BoardModel } from './boardMVC/models/board/BoardModel';
import type { LevelTasksTracker } from './tasks/LevelTasksTracker';

interface GameEndFlowControllerDependencies {
  boardModel: BoardModel;
  taskTracker: LevelTasksTracker;
}

export class GameEndFlowController {
  public readonly onLevelWon = new Signal();

  public readonly onOutOfSpace = new Signal();

  constructor(private readonly dependencies: GameEndFlowControllerDependencies) {}

  public checkLevelWon(): boolean {
    const { taskTracker } = this.dependencies;
    if (taskTracker.getCombinedProgress() < 1) return false;
    this.onLevelWon.emit();
    return true;
  }

  public checkOutOfSpace(): boolean {
    const { boardModel, taskTracker } = this.dependencies;
    if (taskTracker.getCombinedProgress() >= 1 || !boardModel.isBoardFull()) return false;
    this.onOutOfSpace.emit();
    return true;
  }
}
